import React from "react";
import type {GridFilterInputValueProps} from '@mui/x-data-grid';

export const DateBetweenFilterComponent: React.FC<GridFilterInputValueProps> = ({
                                                                                    item,
                                                                                    applyValue,
                                                                                    focusElementRef = null
                                                                                }) => {
    // TODO CAT-2928 NOT IMPLEMENTED YET
    // Should be similar to score between filter
    // Taken from https://mui.com/x/react-data-grid/filtering/customization/#multiple-values-operator

    return <>
    </>;
}
